import React from 'react';
import { DNAButton, DNAButtonProps } from '@alucio/lux-ui';
import usePageBookmarks from 'src/hooks/usePageBookmarks';

export const BookmarkToggle: React.FC = () => {
  const { canEdit, isBookmarked, isSaving, toggle } = usePageBookmarks();
  if (!canEdit) return null;
  return (<DNAButton
    testID="page-bookmark-toggle"
    accessibilityLabel={isBookmarked ? 'Remove page bookmark' : 'Bookmark page'}
    appearance="filled"
    status="subtle"
    colorMode="dark"
    style={{
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      width: 32,
      height: 32,
      minWidth: 32,
      borderRadius: 4,
      borderWidth: 1,
      borderColor: 'rgba(255, 255, 255, 0.24)',
    }}
    iconStyle={{ color: isBookmarked ? 'white' : 'rgb(186, 181, 189)', fontSize: 24 }}
    iconLeft={isBookmarked ? 'bookmark-simple-fill' : 'bookmark-simple'}
    disabled={isSaving}
    onPress={toggle}
  />);
};

export const BookmarkViewButton: React.FC<{
  onOpen: () => void;
  isOpen?: boolean;
  buttonProps?: DNAButtonProps;
  selectedStyle?: Pick<DNAButtonProps, 'appearance' | 'status'>;
}> = ({ onOpen, isOpen, buttonProps, selectedStyle }) => {
  const { pageIds, isSupported, view, setPageNavigationView } = usePageBookmarks();
  if (!isSupported || !pageIds.length) return null;
  return (<DNAButton
    testID="page-bookmarks-view"
    colorMode="dark"
    status="subtle"
    appearance="outline"
    {...buttonProps}
    {...(view === 'bookmarks' && isOpen ? selectedStyle ?? { appearance: 'filled' } : undefined)}
    onPress={() => { setPageNavigationView('bookmarks'); onOpen(); }}
  >Bookmarks</DNAButton>);
};
